import React, { useMemo } from 'react'

import { mainInformationPath, makeSearchPath } from '@/utils'
import HeaderMenu from '@/pages/Home/components/HeaderMenu'
import { useApp, useCurrentPath } from '@/hooks'
import { useData } from '@/pages/Main/useData'
import { t } from '@/i18n'

import { SEARCH_FULL_PATH_SCHEMA, SEARCH_PATH_SCHEMA } from '@/constants'
import LanguageSelector from './LanguageSelector'
import Breadcrumbs from './Breadcrumbs'
import AppSidebar from './AppSidebar'
import AppLayout from './AppLayout'
import { useCanWrite } from '@/hooks'
const routes = [{ path: SEARCH_PATH_SCHEMA }, { path: SEARCH_FULL_PATH_SCHEMA }]

const AppLayoutWithSidebar: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { me } = useApp()
  const route = useCurrentPath(routes)

  const { data } = useData({ id: route.customerId })

  const breadcrumbs = useMemo(
    () => [
      {
        name: data?.name || t('customer'),
        path: makeSearchPath(mainInformationPath, {
          customerId: route.customerId,
        }),
      },
      ...(route.path
        ? [
            {
              name: t(route.path === 'main' ? 'main_information' : route.path),
              path: route.id
                ? route.pathname?.split(`/${route.id}`)[0]
                : route.pathname,
            },
            ...(route.id
              ? [
                  {
                    name: route.id,
                  },
                ]
              : []),
          ]
        : []),
    ],
    [route, data?.name],
  )
  const canWrite = useCanWrite()

  return (
    <AppLayout
      hasFooter
      headerRight={
        <div className="app-right-container">
          <LanguageSelector />
          {canWrite && <HeaderMenu />}
        </div>
      }
    >
      <div className="data-wrap">
        {data?.name && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        <div className="main-box">
          <AppSidebar />
          <div className="info-content">{children}</div>
        </div>
      </div>
    </AppLayout>
  )
}

export default AppLayoutWithSidebar
